<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div
          v-show="stateArrow"
          id="leftBox"
          class="leftBox"
          style="width: 206px"
        >
          <vue-draggable-resizable
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <el-scrollbar>
              <tree
                :isSearch="isSearch"
                @initFun="initQuery"
                @nodeClick="nodeClick"
              ></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i
            :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"
          ></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('DriverManagement.driverNum')">
                    <el-input
                      size="mini"
                      v-model="formInline.driverNum"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('DriverManagement.name')">
                    <el-input
                      size="mini"
                      v-model="formInline.driverName"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('DriverManagement.state')">
                    <el-select
                      v-model="formInline.state"
                      :placeholder="$t('common.form.state')"
                      filterable
                      size="mini"
                      style="width: 120px"
                    >
                      <el-option
                        v-for="item in StateList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{$t('common.btn.search')}}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del"
                      >{{$t('common.btn.cancel')}}</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button v-if="isPrimaryKey('DRIVERSTATUS_DOWN')" type="text" @click="downCar">{{$t('common.btn.download')}}</el-button>
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="800px"
        :visible.sync="dialogFormVisible"
        :title="$t('common.btn.operate')"
        class="tableDialong"
        :close-on-click-modal="false"
      >
        <div class="allDialong">
          <DriverSwiping
            :bind-drive="driverNum"
            ref="driverSwiping"
          ></DriverSwiping>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import DriverStatus from "./DriverStatus.js";
export default DriverStatus;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
